// Helpers for tracking *when* a "watched/played with X" tag was applied, separate from when the
// item itself was first added (created_at). This lets "Newest" sorting reflect the moment the tag
// was given (e.g. adding "watched with Joy" on a rewatch) instead of the original creation date.

// Call from an edit-save handler: for each tag, compares its previous (saved) value to the new
// (form) value and returns only the "_at" fields that need to change. A tag that just got checked
// is stamped with now; a tag that got unchecked has its timestamp cleared. Tags left unchanged are
// omitted so their existing timestamp is preserved.
export function tagAtPatchOnEdit(tags) {
  const now = new Date().toISOString();
  const patch = {};
  tags.forEach(({ wasOn, isOn, atField }) => {
    if (!wasOn && isOn) patch[atField] = now;
    else if (wasOn && !isOn) patch[atField] = null;
  });
  return patch;
}

// Call when creating a new item: any tag that's already checked at creation time is stamped with
// now, since that's also the moment the tag was given.
export function tagAtPatchOnCreate(tags) {
  const now = new Date().toISOString();
  const patch = {};
  tags.forEach(({ isOn, atField }) => {
    if (isOn) patch[atField] = now;
  });
  return patch;
}

// Given the active "filter by person" value and a map of { personValue: atFieldName }, returns a
// comparator that sorts newest-first by that person's tag timestamp (falling back to created_at
// for items that predate tracking). Falls back to plain created_at sorting when no person is
// selected.
export function byTagAtOrCreatedAt(personValue, atFieldByPerson) {
  const atField = personValue ? atFieldByPerson[personValue] : null;
  return (a, b) => {
    const aTime = new Date((atField && a[atField]) || a.created_at).getTime();
    const bTime = new Date((atField && b[atField]) || b.created_at).getTime();
    return bTime - aTime;
  };
}
